export default "__VITE_ASSET__B1V6IDx6__"